import {
  login, logout, register, bindMobile, getUserLoginWithQueryToken,
} from '@/services/user';
import {
 getAuth, getUID, locationHref, setAuth,
} from '@/utils';
import { loginRegisterWithMobile } from '@/services/app';

const userInfoInit = {
  avatar: require('@/assets/img/default/avatar.png'), // eslint-disable-line global-require,
  name: '立即登录',
};

const userNotifyDotInit = {
  unusedCoupon: 0,
  onGoingGroupbuy: 0,
  updateProgram: 0,
  notGivingGift: 0,
  unPaidOrder: 0,
  newMessage: 0,
  newNotification: 0,
};

const user = {
  state: {
    id: getUID() || 0,
    auth: getAuth() || '',
    user: userInfoInit,
    userNotifyDot: userNotifyDotInit,
  },
  getters: {
    userId: state => state.id,
    auth: state => state.auth,
    user: state => state.user,
    userNotifyDot: state => state.userNotifyDot,
  },
  mutations: {
    SET_ID: (state, data) => {
      state.id = data;
    },
    SET_AUTH: (state, data) => {
      state.auth = data;
    },
    SET_USER: (state, data) => {
      state.user = data;
    },
    SET_USER_NOTIFY_DOT: (state, data) => {
      state.userNotifyDot = data;
    },
  },
  actions: {
    updateAuth({ commit }) {
      const auth = getAuth();
      commit('SET_AUTH', auth);
      commit('SET_ID', getUID());
    },
    updateUser({ commit }, payload) {
      commit('SET_USER', payload);
    },
    updateUserNotifyDot({ commit }, payload) {
      commit('SET_USER_NOTIFY_DOT', payload);
    },
    Login({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          let data;
          if (payload.smsType) {
            data = await loginRegisterWithMobile({
              mobile: payload.mobile,
              sms_code: payload.smsCode,
              sms_type: payload.smsType,
            });
          } else {
            data = await login(payload.username, payload.password, payload.agency);
          }
          if (data.isLock) {
            locationHref(`${window.location.origin}/account/lock?lockToken=${data.lockToken}`);
            return reject();
          }
          const auth = getAuth();
          commit('SET_AUTH', auth);
          commit('SET_ID', getUID());
          return resolve(data);
        } catch (e) {
          return reject(e);
        }
      });
    },
    BindMobile({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await bindMobile(
            payload.mobile,
            payload.smsCode,
            payload.wechat,
          );
          const auth = getAuth();
          commit('SET_AUTH', auth);
          commit('SET_ID', getUID());
          return resolve(data);
        } catch (e) {
          return reject(e);
        }
      });
    },
    Register({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await register(
            payload.mobile,
            payload.smsCode,
            payload.password,
            payload.passwordCheck,
          );
          const auth = getAuth();
          commit('SET_AUTH', auth);
          commit('SET_ID', getUID());
          return resolve(data);
        } catch (e) {
          return reject(e);
        }
      });
    },
    Logout({ commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          await logout();
          commit('SET_ID', 0);
          commit('SET_AUTH', '');
          commit('SET_USER', userInfoInit);
          commit('SET_USER_NOTIFY_DOT', userNotifyDotInit);
          setAuth('');
          return resolve();
        } catch (e) {
          return reject(e);
        }
      });
    },
    LoginWithQueryToken({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          await this.dispatch('Logout');
          const { mWApiToken, miniToken, mApiToken } = payload;
          const data = await getUserLoginWithQueryToken({
            mWApiToken,
            miniToken,
            mApiToken,
          });
          if (data.isLock) {
            locationHref(`${window.location.origin}/account/lock?lockToken=${data.lockToken}`);
            return reject();
          }
          const auth = getAuth();
          commit('SET_AUTH', auth);
          commit('SET_ID', getUID());
          return resolve();
        } catch (e) {
          return reject(e);
        }
      });
    },
  },
};

export default user;
